module.exports = __webpack_public_path__ + "media/images/icons/icon_mypage_donation_count_primary-b25585169c556fee8bdff6750d4ac338.svg";